import { IconButton, Loading } from '@avantstay/backoffice-core'
import { IconDownload } from '@avantstay/backoffice-vectors'

interface DownloadButtonProps {
  className?: string
  isDownloading: boolean
  onDownload: () => void
}

export const DownloadButton = ({ className, isDownloading, onDownload }: DownloadButtonProps) => {
  return (
    <IconButton.Secondary
      hasTooltip
      className={className}
      type="button"
      label="Download"
      data-testid="download-attachment"
      icon={isDownloading ? <Loading size="4px" /> : <IconDownload />}
      onClick={onDownload}
    />
  )
}
